export default __webpack_public_path__ + "static/media/bt3.9ecedfe5.jpeg";